import { makeAutoObservable } from 'mobx';

export default class SocialResumeCreateRefStore {
  constructor() {
    makeAutoObservable(this);
  }

  resumeBaseInfoRef;

  descriptionRef;

  resumeEduExpListRef;

  resumeWorkExpListRef;

  resumeProjectExpListRef;

  resumeHonorListRef;

  resumeLanguageListRef;

  resumeCertificateListRef;

  resumePatentListRef;

  resumeExamListRef;

  resumeSocialAccountListRef;

  currentScrollRef;

  resumeBaseInfoTitleRef;

  // 校验
  validate = async () => {
    let resumeBaseInfoRefs = true;
    try {
      await this.resumeBaseInfoRef?.asyncValidateFields();
    } catch (error) {
      console.error('基本信息验证失败:', error);
      resumeBaseInfoRefs = false;
    }
    const resumeEduExpListRefs = this.resumeEduExpListRef.map((ref) => ref?.validateFields());
    const resumeWorkExpListRefs = this.resumeWorkExpListRef.map((ref) => ref?.validateFields());
    const resumeProjectExpListRefs = this.resumeProjectExpListRef.map((ref) => ref?.validateFields());
    const resumeHonorListRefs = this.resumeHonorListRef.map((ref) => ref?.validateFields());
    const resumeLanguageListRefs = this.resumeLanguageListRef.map((ref) => ref?.validateFields());
    const resumeCertificateListRefs = this.resumeCertificateListRef.map((ref) => ref?.validateFields());
    const resumePatentListRefs = this.resumePatentListRef.map((ref) => ref?.validateFields());
    const resumeExamListRefs = this.resumeExamListRef.map((ref) => ref?.validateFields());
    const resumeSocialAccountListRefs = this.resumeSocialAccountListRef.map((ref) => ref?.validateFields());

    return [
      resumeBaseInfoRefs,
      ...resumeEduExpListRefs,
      ...resumeWorkExpListRefs,
      ...resumeProjectExpListRefs,
      ...resumeHonorListRefs,
      ...resumeLanguageListRefs,
      ...resumeCertificateListRefs,
      ...resumePatentListRefs,
      ...resumeExamListRefs,
      ...resumeSocialAccountListRefs,
    ].filter((item) => item !== undefined);
  };

  // 修改refs
  changeRef = (key: string, value: any) => {
    this[key] = value;
  };

  setTitleRef = (key: string, value: any) => {
    this[key] = value;
  };

  setCurrentScrollRef = (value: any) => {
    this.currentScrollRef = value;
  };
}
